export interface ButtonGroupOptions<Value = any> {
    container: HTMLElement;
    choices: ButtonGroupItemChoice<Value>[];
    value: Value;
    onChange?: (item: ButtonGroup<Value>) => void;
}

export class ButtonGroup<Value = any> {

    public onChange = e5.Signal.create<[ButtonGroup<Value>]>();

    private _element: HTMLElement;
    private _items: ButtonGroupItem<Value>[] = [];
    private _item: ButtonGroupItem<Value> = null;

    constructor(options: ButtonGroupOptions<Value>) {
        options = e5.object.merge({

        }, options);

        this._element = document.createElement("div");
        this._element.className = "button-group";

        for (let choice of options.choices) {
            this._items.push(
                new ButtonGroupItem({
                    container: this._element,
                    choice: choice,
                    onClick: (item) => {
                        this.item = item;
                    }
                })
            );
        }

        if (typeof options.onChange === "function") {
            this.onChange.add(options.onChange);
        }

        this.value = options.value;

        options.container.appendChild(this._element);
    }

    public get value(): Value {
        return this._item ? this._item.choice.value : null;
    }

    public set value(value: Value) {
        for (let item of this._items) {
            if (item.choice.value === value) {
                this.item = item;
                return;
            }
        }
    }

    public get id(): number {
        return this._item ? this._item.choice.id : null;
    }

    public set id(id: number) {
        for (let item of this._items) {
            if (item.choice.id === id) {
                this.item = item;
                return;
            }
        }
    }

    private get item(): ButtonGroupItem<Value> {
        return this._item;
    }

    private set item(item: ButtonGroupItem<Value>) {

        if (this._item === item) {
            return;
        }

        if (this._item) {
            this._item.active = false;
        }

        this._item = item;

        if (this._item) {
            this._item.active = true;
        }

        this.onChange.dispatch(this);
    }

    public dispose(): void {
        this.onChange.dispose();
        this._element.remove();

        this._element = null;
        this.onChange = null;
    }
}

interface ButtonGroupItemOptions<Value = any> {
    container: HTMLElement;
    choice: ButtonGroupItemChoice<Value>;
    onClick: (item: ButtonGroupItem<Value>) => void;
}

interface ButtonGroupItemChoice<Value = any> {
    id: number;
    value: Value;
    label?: string;
    icon?: string;
}

class ButtonGroupItem<Value = any> {
    private _element: HTMLElement;
    public readonly choice: ButtonGroupItemChoice<Value>;

    constructor(options: ButtonGroupItemOptions<Value>) {
        options = e5.object.merge({

        }, options);

        this._element = document.createElement("button");
        this._element.className = "button-group__item";
        this._element.innerHTML = `
        <span class="button-group__item-label ${options.choice.label ? '' : 'e5-hidden'}">${e5.Text.escapeHtml(options.choice.label)}</span>
        <span class="button-group__item-icon ${options.choice.icon || 'e5-hidden'}"></span>
        `;

        this.choice = options.choice;

        this._element.addEventListener("click", () => {
            options.onClick(this);
        });

        options.container.appendChild(this._element);
    }

    public get active(): boolean {
        return this._element.classList.contains("button-group__item--active");
    }

    public set active(active: boolean) {
        this._element.classList.toggle("button-group__item--active", active);
    }
}